import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PushNotificationsComponent } from './push-notifications/push-notifications.component';
import { AddUpdatePushNotificationsComponent } from './add-update-push-notifications/add-update-push-notifications.component';

const routes: Routes = [
  {
    path: '',
    component: PushNotificationsComponent,
  },
  {
    path: 'add',
    component: AddUpdatePushNotificationsComponent,
  },
  {
    path: 'update/:id',
    component: AddUpdatePushNotificationsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PushNotificationRoutingModule {}
